{
  "got-it": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "mercury.mercury-groups-configure-permissions.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "mercury.mercury-groups-configure-permissions.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "mercury.mercury-groups-configure-permissions.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "mercury.mercury-groups-configure-permissions.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "mercury.mercury-groups-configure-permissions.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "mercury.mercury-groups-configure-permissions.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "mercury.mercury-groups-configure-permissions.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "mercury.mercury-monthly-digest.email.arrow-icon.alt": [
    {
      "type": 0,
      "value": "arrow-icon"
    }
  ],
  "mercury.mercury-monthly-digest.email.arrow-right-icon.alt": [
    {
      "type": 0,
      "value": "arrow-right-icon"
    }
  ],
  "mercury.mercury-monthly-digest.email.calendar-icon.alt": [
    {
      "type": 0,
      "value": "calendar-icon"
    }
  ],
  "mercury.mercury-monthly-digest.email.catch.up.link": [
    {
      "type": 0,
      "value": "Jump into Atlassian Focus"
    }
  ],
  "mercury.mercury-monthly-digest.email.catch.up.text": [
    {
      "type": 0,
      "value": "Want to catch up on previous updates? "
    },
    {
      "type": 1,
      "value": "link"
    }
  ],
  "mercury.mercury-monthly-digest.email.date-changed": [
    {
      "type": 0,
      "value": "Date Changed"
    }
  ],
  "mercury.mercury-monthly-digest.email.focus-area-icon.alt": [
    {
      "type": 0,
      "value": "Focus area icon"
    }
  ],
  "mercury.mercury-monthly-digest.email.footer.atlassian-logo.alt": [
    {
      "type": 0,
      "value": "Atlassian footer"
    }
  ],
  "mercury.mercury-monthly-digest.email.footer.sent-by": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Focus"
    }
  ],
  "mercury.mercury-monthly-digest.email.footer.unsubscribe": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "mercury.mercury-monthly-digest.email.for": [
    {
      "type": 0,
      "value": "for"
    }
  ],
  "mercury.mercury-monthly-digest.email.header.logoAltText": [
    {
      "type": 0,
      "value": "Focus Logo"
    }
  ],
  "mercury.mercury-monthly-digest.email.no-target-date.alt": [
    {
      "type": 0,
      "value": "No target date set"
    }
  ],
  "mercury.mercury-monthly-digest.email.status-changed": [
    {
      "type": 0,
      "value": "Status changed"
    }
  ],
  "mercury.mercury-monthly-digest.email.total-following.sub-header": [
    {
      "type": 0,
      "value": "You're following "
    },
    {
      "type": 1,
      "value": "total"
    },
    {
      "type": 0,
      "value": " active focus areas, here's the breakdown."
    }
  ],
  "mercury.mercury-monthly-digest.email.view-update": [
    {
      "type": 0,
      "value": "View Update"
    }
  ],
  "mercury.mercury-monthly-digest.message-template.email.subject.no-translate": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ", here are your monthly focus area updates"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.automations.cta-text.no-translate": [
    {
      "type": 0,
      "value": "Explore automations"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.automations.cta-url.no-translate": [
    {
      "type": 0,
      "value": "https://support.atlassian.com/cloud-automation/docs/use-focus-with-jira-automations/"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.automations.description.no-translate": [
    {
      "type": 0,
      "value": "Automatically add Jira work to focus areas based on criteria like project, team, assignee, and more."
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.automations.title.no-translate": [
    {
      "type": 0,
      "value": "Work linking automation"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.group-permissions.cta-text.no-translate": [
    {
      "type": 0,
      "value": "Configure permissions"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.group-permissions.cta-url.no-translate": [
    {
      "type": 0,
      "value": "https://support.atlassian.com/focus/docs/manage-user-group-permissions/"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.group-permissions.description.no-translate": [
    {
      "type": 0,
      "value": "You can now configure permissions by user group — giving you more control over who can edit focus areas."
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.group-permissions.title.no-translate": [
    {
      "type": 0,
      "value": "Group permissions"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.work-improvements.cta-text.no-translate": [
    {
      "type": 0,
      "value": "Visit focus areas"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.work-improvements.cta-url.no-translate": [
    {
      "type": 0,
      "value": "https://helium.jira-dev.com/focus/reviews"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.work-improvements.description.no-translate": [
    {
      "type": 0,
      "value": "We've released updates to work in Focus, including custom Jira Align terminology, improved Jira status mapping, and rollups from child focus areas."
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.work-improvements.title.no-translate": [
    {
      "type": 0,
      "value": "Work improvements"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.heading.no-translate": [
    {
      "type": 0,
      "value": "Feature highlights"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.icon.alt.no-translate": [
    {
      "type": 0,
      "value": "Feature icon"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.subheading.no-translate": [
    {
      "type": 0,
      "value": "Check out what's new and improved in Focus."
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area-summary.heading.no-translate": [
    {
      "type": 0,
      "value": "Your team has created "
    },
    {
      "type": 1,
      "value": "noOfFocusAreas"
    },
    {
      "type": 0,
      "value": " new focus areas — follow to get notified of progress."
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.created-by.no-translate": [
    {
      "type": 1,
      "value": "relativeDate"
    },
    {
      "type": 0,
      "value": " · created by "
    },
    {
      "type": 1,
      "value": "userName"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.created-date.no-translate": [
    {
      "type": 1,
      "value": "relativeDate"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.created.days-ago.no-translate": [
    {
      "offset": 0,
      "options": {
        "=1": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day ago"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days ago"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.created.hours-ago.no-translate": [
    {
      "offset": 0,
      "options": {
        "=1": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " hour ago"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " hours ago"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.created.minutes-ago.no-translate": [
    {
      "offset": 0,
      "options": {
        "=1": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " minute ago"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " minutes ago"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.created.months-ago.no-translate": [
    {
      "offset": 0,
      "options": {
        "=1": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " month ago"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " months ago"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.created.seconds-ago.no-translate": [
    {
      "offset": 0,
      "options": {
        "=0": {
          "value": [
            {
              "type": 0,
              "value": "just now"
            }
          ]
        },
        "=1": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " second ago"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " seconds ago"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.created.weeks-ago.no-translate": [
    {
      "offset": 0,
      "options": {
        "=1": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " week ago"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " weeks ago"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.icon.alt-text": [
    {
      "type": 0,
      "value": "Focus area icon"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-logo.alt-text": [
    {
      "type": 0,
      "value": "Focus logo"
    }
  ],
  "mercury.mercury-re-engage-whats-new.follow-button.no-translate": [
    {
      "type": 0,
      "value": "Follow"
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.banner.alt.no-translate": [
    {
      "type": 0,
      "value": "Strategy Collection"
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.footer.address.no-translate": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.footer.atlassian-logo-alt.no-translate": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.footer.copyright.no-translate": [
    {
      "type": 0,
      "value": "Copyright 2025 Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.footer.sent-by.no-translate": [
    {
      "type": 0,
      "value": "This email was sent to you by Atlassian Focus"
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.footer.unsubscribe.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.header.no-translate": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ", your team created "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "count"
        }
      ],
      "type": 8,
      "value": "countSpan"
    },
    {
      "type": 0,
      "value": " new Focus areas"
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.pre-header.no-translate": [
    {
      "type": 0,
      "value": "New ways to connect work and keep your team aligned."
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "What’s new in Focus"
    }
  ],
  "mercury.mercury-re-engage-whats-new.test-message.email.header.sub-text.no-translate": [
    {
      "type": 0,
      "value": "Follow to stay informed and get notified of progress."
    }
  ],
  "mercury.message-templates.edit-focus-area-heirarchy-spotlight-body": [
    {
      "type": 0,
      "value": "Whenever you need to make changes to your hierarchy you can do so from settings."
    }
  ],
  "mercury.message-templates.edit-focus-area-heirarchy-spotlight-heading": [
    {
      "type": 0,
      "value": "Edit your focus area hierarchy"
    }
  ]
}